import React from "react";
import ContractForm from "./ContractForm";

export default function NewContract() {
  return <ContractForm />;
}
